<template>
    <form class="form" autoComplete="off" :id=formName :name=formName noValidate="" method="POST">
        <div class="form-group">
            <label for="inputResetPasswordEmail">Email</label>
            <input type="email" class="form-control" id="inputResetPasswordEmail" required="" />
            <span id="helpResetPasswordEmail" class="form-text small text-muted">
                Password reset instructions will be sent to this email address.
            </span>
        </div>
        <div class="form-group">
            <button type="submit" class="btn btn-primary btn-lg float-right">{{ submitBtnText }}</button>
        </div>
    </form>
</template>
<script>
export default {
    props: {
        formName: 'formReset',
        submitBtnText: {
            type: String,
            default: "Reset Password"            
        }
    }
};
</script>
